/** What the page shows before anything is sent: the file's counts, read locally. */
export interface ImportSummary {
  readonly version: 1;
  readonly companyCards: number;
  readonly personalCards: number;
  readonly vehicles: number;
  readonly suppliers: number;
}

export type ParsedImport =
  | { readonly ok: true; readonly summary: ImportSummary; readonly body: Record<string, unknown> }
  | { readonly ok: false; readonly reason: 'not-json' | 'not-version-1' };

function list(value: unknown): readonly unknown[] {
  return Array.isArray(value) ? value : [];
}

/** Reads the nexpense import file (format version 1); the server validates it again. */
export function parseImportFile(text: string): ParsedImport {
  let data: unknown;
  try {
    data = JSON.parse(text);
  } catch {
    return { ok: false, reason: 'not-json' };
  }
  if (typeof data !== 'object' || data === null || Array.isArray(data)) {
    return { ok: false, reason: 'not-version-1' };
  }
  const body = data as Record<string, unknown>;
  if (body['version'] !== 1) return { ok: false, reason: 'not-version-1' };
  const cards = list(body['cards']);
  const personal = cards.filter(
    (card) =>
      typeof card === 'object' && card !== null && (card as { kind?: unknown }).kind === 'personal',
  ).length;
  return {
    ok: true,
    body,
    summary: {
      version: 1,
      companyCards: cards.length - personal,
      personalCards: personal,
      vehicles: list(body['vehicles']).length,
      suppliers: list(body['suppliers']).length,
    },
  };
}
